module.exports = require("@swa-ui/authentication/src/components/MfaContactSelectForm/MfaContactSelectForm.module.scss");